// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import FormDialog from '../../components/Dialog/FormDialog';
import CheckboxInput from '../../components/Form/CheckboxInput';

export const CommercialAgreementDataPublishingConsentDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  title: string;
  submitName: string;
  initialValue: boolean;
  onSubmit: (consent: boolean) => Promise<unknown>;
}> = ({ open, onClose, title, submitName, initialValue, onSubmit }) => {
  const [consent, setConsent] = React.useState(initialValue);

  React.useEffect(() => {
    if (!open) return;
    setConsent(initialValue);
  }, [open, initialValue]);

  const handleSubmit = React.useCallback(() => {
    return onSubmit(consent).finally(() => onClose());
  }, [consent, onClose, onSubmit]);

  return (
    <FormDialog
      open={open}
      title={title}
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName={submitName}
    >
      <CheckboxInput label="Consent to data publishing" checked={consent} setChecked={setConsent} />
    </FormDialog>
  );
};
